<template>
    <proposal-iframe
        :padding="true"
        overflow="hidden"
        id="proposal-iframe"
        ref="iframe"
        style="width: 100%; border: 0"
        :style="iframeStyles"
        @loaded="resizeIframe"
    >
        <proposal-pricing-option
            v-if="form_data['pricing_option' + number].is_active"
            v-model="localValue"
            :data="form_data['pricing_option' + number]"
            :recommended="number === 2"
        />
    </proposal-iframe>
</template>

<script>
import ProposalIframe from './proposal-iframe.vue';
import ProposalPricingOption from '../../../ProposalsPresentation3/vue/parts/proposal-31-pricing-option.vue';

export default {
    components: {
        ProposalIframe,
        ProposalPricingOption,
    },
    props: {
        form_data: {
            type: Object,
            required: true,
        },
        number: {
            type: Number,
            required: true,
        },
        // true when this option's tab is the active one; the iframe can only be measured while visible
        visible: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            localValue: 0,
            iframeHeight: "500px",
        };
    },
    computed: {
        optionData() {
            return this.form_data['pricing_option' + this.number];
        },
        iframeStyles() {
            return {
                height: this.iframeHeight,
            };
        },
    },
    watch: {
        // grow/shrink the iframe whenever the previewed plan changes (price, includes, add-on, …)
        optionData: {
            deep: true,
            handler() {
                this.$nextTick(() => this.resizeIframe());
            },
        },
        // Element UI keeps inactive tab-panes in the DOM but display:none, so the iframe gets measured
        // as 0px height while hidden. Re-measure once this option's tab actually becomes visible.
        visible(isVisible) {
            if (isVisible) {
                this.$nextTick(() => this.setIframeHeight());
                setTimeout(() => this.setIframeHeight(), 100);
            }
        },
    },
    methods: {
        resizeIframe() {
            const iframe = this.$refs.iframe;
            if (!iframe) {
                return;
            }

            const imgs = iframe.$el.contentWindow.document.querySelectorAll("img");
            imgs.forEach((img) => {
                if (!img.complete) {
                    img.addEventListener('load', () => {
                        this.$nextTick(() => this.setIframeHeight());
                    });
                }
            });

            this.setIframeHeight();
        },
        setIframeHeight() {
            if (!this.$refs.iframe) {
                return;
            }

            const divEl = this.$refs.iframe.$el.contentWindow.document.querySelector('body div');
            if (divEl) {
                this.iframeHeight = (divEl.offsetHeight + 16) + 'px';
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.setIframeHeight);

        // the card height settles after fonts/layout; re-measure a couple of times
        setTimeout(() => this.setIframeHeight(), 500);
        setTimeout(() => this.setIframeHeight(), 1500);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setIframeHeight);
    },
};
</script>
